import { render, staticRenderFns } from "./TablePagination.vue?vue&type=template&id=06db895c&scoped=true"
import script from "./TablePagination.vue?vue&type=script&lang=js"
export * from "./TablePagination.vue?vue&type=script&lang=js"
import style0 from "./TablePagination.vue?vue&type=style&index=0&id=06db895c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06db895c",
  null
  
)

export default component.exports